import './App.css';
import './Assets/scss/style.scss';
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { publicRoutes } from './router/public.route';
import { Routes as GlobalRoutes } from "./constants/RouteConstants";
import Login from './component/login/Login';
import Signup from './component/signup/Signup';
import Home from './component/home/Home';
import PrivateRoute from './router/PrivateRoutes';
import Layout from './component/layout/Layout';
import { routeComponents } from './config/RouteConfig';
import ToastDefault from './component/layout/Toast';
import Cms from './component/cms/Cms';
import Faq from './component/faq/Faq';
import { Config } from './config/Config';
import Product from './component/product/Product';
import ProductDetails from './component/product/ProductDetails';
import AppCms from './component/cms/AppCms';
import UserFaq from './component/faq/UserFaq';
import PageNotFound from './component/layout/PageNotFound';
import Success from './component/layout/Success';
import Cancel from './component/layout/Cancel';


function App() {

  const publicRoutes = [
    {
      path: GlobalRoutes?.Login,
      element: <Login />,
    },
    {
      path: GlobalRoutes?.Signup,
      element: <Signup />,
    },
    {
      path: GlobalRoutes?.AppPrivacyPolicyCMS,
      element: <AppCms />,
    },
    {
      path: GlobalRoutes?.AppTermCondition,
      element: <AppCms />,
    },
    {
      path: GlobalRoutes?.AppAboutUs,
      element: <AppCms />,
    },
    {
      path: GlobalRoutes?.UserFaq,
      element: <UserFaq />,
    },
    {
      path: GlobalRoutes?.Paymentsuccess,
      element: <Success />,
    },
    {
      path: GlobalRoutes?.Paymentscancel,
      element: <Cancel />,
    },
    {
      path: GlobalRoutes?.PageNotFound,
      element: <PageNotFound />,
    },
   

  ]




  return (
    <>
      <BrowserRouter basename={Config?.BASE_URL}>
        {/* <Header /> */}
        <Routes >

        <Route element={<Layout />}>
                <Route path={"/"} element={<Home/>} ></Route>
                <Route path={"/cms/:id"} element={<Cms/>} ></Route>
                <Route path={"/faq"} element={<Faq/>} ></Route>
                <Route path={"/product"} element={<Product/>} ></Route>
                <Route path={"/productdetail/:id"} element={<ProductDetails/>} ></Route>
                {/* <Route path={"*"} element={<PageNotFound/>} ></Route> */}
         </Route>
          <Route>
            {
              publicRoutes?.map((route: any, routeKey: any) => {
                return <Route path={route?.path} element={route?.element} key={routeKey} />
              })
            }
          </Route>
          <Route element={<PrivateRoute component={Layout} />}>
            {routeComponents}
          </Route>
        </Routes>
        {/* <Footer /> */}
      </BrowserRouter>
      <ToastDefault />
    </>
  );
}

export default App;
